import { SB_CLOSE_ALL } from "../../types/sidebars";

export default params => (state = false, action) => {
  switch (action.type) {
    case "SB_" + params.code + "_OPEN":
      return true;
    case "SB_" + params.code + "_CLOSE":
    case SB_CLOSE_ALL:
      return false;
    default:
      return state;
  }
};
